import type { InputHTMLAttributes, ReactNode } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    fullWidth?: boolean;
    rightElement?: ReactNode;
}

export function Input({
    label,
    error,
    fullWidth = false,
    className = '',
    id,
    rightElement,
    ...props
}: InputProps) {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    const wrapperClasses = [
        styles.inputWrapper,
        error ? styles.error : '',
        fullWidth ? styles.fullWidth : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    const inputClasses = [styles.input, rightElement ? styles.hasRightElement : '']
        .filter(Boolean)
        .join(' ');

    return (
        <div className={wrapperClasses}>
            {label && (
                <label htmlFor={inputId} className={styles.label}>
                    {label}
                </label>
            )}
            <div className={styles.inputContainer}>
                <input id={inputId} className={inputClasses} {...props} />
                {rightElement && <div className={styles.rightElement}>{rightElement}</div>}
            </div>
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
}
